var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-trust-order-data')
}
var staticRenderFns = []

export { render, staticRenderFns }